/* eslint-disable */
import React, { useState } from "react";
import { withRouter } from "react-router";

import { Helmet } from "react-helmet";

import FormForgot from "../../components/FormForgot";
import FormReset from "../../components/FormReset";

const ForgotPassword = ({ history, location }) => {
  const [lastForgetRequest, setLastForgetRequest] = useState(false);

  const onForgot = (forgetRequest) => setLastForgetRequest(forgetRequest);
  const onReset = () =>
    history.push({
      pathname: "/login",
    });

  const title = location.pathname === "/activation" ? "Bienvenido a PIN" : "Recupere su contraseña";
  const resetAction = location.pathname === "/activation" ? "Generar Contraseña" : "Cambiar Contraseña";
  const forgotAction = location.pathname === "/activation" ? "Continuar" : "Recuperar Contraseña";

  return (
    <div>
      <Helmet>
        <title>PIN - Recuperar contraseña</title>
      </Helmet>
      {lastForgetRequest ? (
        <FormReset history={history} lastForgetRequest={lastForgetRequest} onReset={onReset} title={title} action={resetAction} />
      ) : (
        <FormForgot history={history} lastForgetRequest={lastForgetRequest} onForgot={onForgot} title={title} action={forgotAction} />
      )}
    </div>
  );
};

export default withRouter(ForgotPassword);
